/* Post-success only. Defer until the native cart drawer closes; never replace ATC. */
(function () {
  'use strict';
  if (window.ptSoloMatchIt) return;
  window.ptSoloMatchIt = true;
  var pending = null;
  function show() {
    if (!pending || theme.settings.afterAddToCart === 'page') return;
    if (document.querySelector('.js-cart-drawer[open], modal-dialog[open]')) return;
    var modal = pending.section.querySelector('[data-solo-match-it]');
    if (!modal || typeof modal.open !== 'function') return;
    var opener = pending.opener;
    pending = null;
    modal.open(opener);
  }
  function added(event) {
    var section = event.target.closest && event.target.closest('.section-main-product');
    if (!section || !section.querySelector('[data-solo-options]') || !section.querySelector('[data-solo-match-it]')) return;
    pending = { section: section, opener: section.querySelector('[name="add"]') };
    show();
  }
  document.addEventListener('on:cart:add', added);
  document.addEventListener('on:solo:cart:add', added);
  // Cart drawer uses the native open attribute; observe only its state.
  function init() {
    var drawer = document.querySelector('.js-cart-drawer');
    if (drawer) new MutationObserver(show).observe(drawer, { attributes: true, attributeFilter: ['open'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
